import React from 'react';
import { Button, Tooltip } from 'antd';
import { FormField, maxLength, alphaNumeric } from 'common';

const ButtonGroup = Button.Group;
const warn = [maxLength(50), alphaNumeric];

const Corporation: any = ({
  fields,
  meta: { error },
  handleFieldFocus,
}: any) => {
  const addLimit = 10;
  const removeLimit = 1;

  return (
    <>
      {fields.map((corporation: any, index: number) => (
        <FormField
          key={index}
          onFocus={handleFieldFocus}
          warn={warn}
          label={index === 0 ? 'Corp Name' : ''}
          name={`${corporation}`}
          addonAfter={
            <ButtonGroup>
              <Tooltip title={`Remove Corporation Name`}>
                <Button
                  type="link"
                  size="small"
                  icon="minus"
                  onClick={() => fields.remove(index)}
                  disabled={fields.length === removeLimit}
                />
              </Tooltip>
              {fields.length - 1 === index && (
                <Tooltip
                  title={`Add Corporation Name Variation (the limit is ${addLimit} variations)`}
                >
                  <Button
                    type="link"
                    size="small"
                    icon="plus"
                    onClick={() => fields.push('')}
                    disabled={fields.length >= addLimit}
                  />
                </Tooltip>
              )}
            </ButtonGroup>
          }
        />
      ))}
    </>
  );
};

export default Corporation;
